import { ChevronRightIcon } from "@heroicons/react/outline";
import { query, collection, where, onSnapshot } from "firebase/firestore";
import { useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { GetCellphonesState } from "../../../../domain/usecases/get-cellphone";
import { db } from "../../../../main/firebase";
import { currentAccountState } from "../../../components";
import Loading from "../../../components/loading/loading";
import { manageCellphoneState, toggleEditCellphoneState } from "./atoms/atoms";
import CellphoneRows from "./cellphoneRows";

export default function ManageCellphones() {
  const [state, setState] = useRecoilState(manageCellphoneState);
  const [toggleState, setToggleState] = useRecoilState(
    toggleEditCellphoneState
  );

  const { getCurrentAccount } = useRecoilValue(currentAccountState);

  useEffect(() => {
    const q = query(
      collection(db, "cellphone"),
      where("account", "==", getCurrentAccount().account)
    );

    return onSnapshot(q, (querySnapshot) => {
      let cellphones = querySnapshot.docs
        .sort((a, b) => a.data().displayName - b.data().displayName)
        .map((doc) => {
          console.log("doc.data()", doc.data());
          return {
            id: doc.id,
            account: doc.data().account,
            approvedBy: doc.data().approvedBy,
            createdBy: doc.data().createdBy,
            dateCreated: doc.data().dateCreated.toDate(),
            dateUpdated: doc.data().dateUpdated.toDate(),
            emailContact: doc.data().emailContact,
            isActive: doc.data().isActive,
            location: doc.data().location,
            cellphone_id: doc.data().cellphone_id,
            number: doc.data().number,
            cellphoneOwner: doc.data().cellphoneOwner,
            network: doc.data().network,
            jobTitle: doc.data().jobTitle,
            status: doc.data().status,
            company: doc.data().company,
            rejectionReason: doc.data().rejectionReason
              ? doc.data().rejectionReason
              : null,
            disabledReason: doc.data().disabledReason
              ? doc.data().disabledReason
              : null,
          } as GetCellphonesState.Model;
        });

      setState((old) => ({
        ...old,
        cellphones: cellphones,
        isLoading: false,
      }));
    });
  }, []);

  // useEffect(() => {
  //   getActiveCellphones
  //     .fetch({
  //       cellphoneStatus: "Active",
  //       accountNumber: getCurrentAccount().account,
  //     })
  //     .then((result) =>
  //       setState((old) => ({
  //         ...old,
  //         cellphones: result.map((cellphone, index) => {
  //           console.log("cellphone", cellphone);
  //           return {
  //             id: index,
  //             account: cellphone.account.toString(),
  //             merchant: getCurrentAccount().merchantName,
  //             location: cellphone.location,
  //             name: cellphone.name,
  //             number: cellphone.number,
  //             purchaseAmount: 0.0,
  //             lastPurchaseDate: "None",
  //             lastPurchaseAmount: 0.0,
  //           };
  //         }),
  //         isLoading: false,
  //       }))
  //     )
  //     .catch(handleError);
  // }, []);

  const toggleEditCellphoneClick = async (e: React.SyntheticEvent) => {
    e.preventDefault();

    setToggleState((old) => ({
      ...old,
      toggle: !toggleState.toggle,
    }));
  };

  const cellphones =
    state.cellphones &&
    state.cellphones.map((cellphone, index) => {
      return (
        <CellphoneRows
          key={cellphone.number}
          index={index}
          cellphone={cellphone}
        />
      );
    });

  return (
    <>
      {state.cellphones && (
        <div className="w-full bg-white overflow-hidden shadow rounded-sm">
          <div className="px-4 py-5 sm:px-6">
            <h2 className="max-w-7xl mx-auto  text-lg leading-6 font-medium text-gray-900">
              Cellphones
            </h2>
          </div>
          <div className="px-6 pb-6">
            {/* Activity list (smallest breakpoint only) */}
            <div className="shadow sm:hidden">
              <ul className="mt-2 divide-y divide-gray-200 overflow-hidden shadow sm:hidden">
                {state.cellphones.map((cellphone) => (
                  <li key={cellphone.number}>
                    <a
                      href={cellphone.number}
                      className="block px-4 py-4 bg-white hover:bg-gray-50"
                    >
                      <span className="flex items-center space-x-4">
                        <span className="flex-1 flex space-x-2 truncate">
                          <span className="flex flex-col text-gray-500 text-sm truncate">
                            <span className="truncate">{cellphone.number}</span>
                            <span>
                              <span className="text-gray-900 font-medium">
                                {cellphone.jobTitle}
                              </span>
                            </span>
                            <div>{cellphone.number}</div>
                          </span>
                        </span>
                        <ChevronRightIcon
                          className="flex-shrink-0 h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </span>
                    </a>
                  </li>
                ))}
              </ul>

              <nav
                className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200"
                aria-label="Pagination"
              >
                <div className="flex-1 flex justify-between">
                  <a
                    href="/"
                    className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"
                  >
                    Previous
                  </a>
                  <a
                    href="/"
                    className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"
                  >
                    Next
                  </a>
                </div>
              </nav>
            </div>

            {/* Activity table (small breakpoint and up) */}
            <div className="hidden  sm:block">
              <div className="max-w-7xl mx-auto">
                <div className="flex flex-col">
                  <div className="align-middle min-w-full flex-grow overflow-x-auto overflow-hidden ">
                    {state.cellphones.length > 0 ? (
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead>
                          <tr>
                            <th className="px-6 py-2  text-left text-sm font-medium text-gray-500  tracking-wider">
                              Job Title
                            </th>
                            <th className="pr-6 py-2  text-left text-sm font-medium text-gray-500  tracking-wider">
                              Number
                            </th>
                            <th className="px-6 py-2 text-left text-sm font-medium text-gray-500  tracking-wider">
                              Owner
                            </th>
                            <th className="px-6 py-2 text-left text-sm font-medium text-gray-500  tracking-wider">
                              Network
                            </th>
                            <th className="px-6 py-2 text-left text-sm font-medium text-gray-500  tracking-wider">
                              Status
                            </th>
                            <th className="px-2 py-2  text-left text-sm font-medium text-gray-500  tracking-wider">
                              Manage
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-100">
                          {cellphones}
                        </tbody>
                      </table>
                    ) : (
                      <h2 className="text-md leading-6 font-medium text-gray-900">
                        Merchant has no cellphones.
                      </h2>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {state.isLoading && <Loading />}
    </>
  );
}
